/* ImportSummaryComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;

const Renderer = require("./ImportSummaryRenderer");

class ImportSummaryComponent extends EventEmitter {
    constructor(importResults, logger) {
        super();
        this._importResults = importResults;
        this._logger = logger;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ImportSummaryComponent.shutdown() error.");
            }
        );
    }

    sendOk() {
        this._context.resolve({});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    getImportResults() {
        return this._importResults;
    }

    get importResults() {
        return this.getImportResults();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ImportSummaryComponent;
